module.exports = __webpack_public_path__ + "static/media/Vegan.a07a3f71.png";